
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/transportbil/volkswagen-caddy",
      function () {
        return require("private-next-pages/wheels/transportbil/volkswagen-caddy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/transportbil/volkswagen-caddy"])
      });
    }
  